import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout de la section « Runs ».
 *
 * Ce fichier est OBLIGATOIRE dès qu'il existe `runs.$runId.tsx` : le
 * générateur de routes rattache l'enfant à ce parent. Sans lui, la route de
 * détail n'est branchée nulle part et une URL profonde rend « Not Found ».
 * Et sans <Outlet />, l'enfant ne s'affiche jamais : l'URL change dans la
 * barre d'adresse mais l'écran reste sur la liste.
 */
export const Route = createFileRoute('/runs')({
  component: () => <Outlet />,
});
